
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"none","stroke":"#C3AFA3","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5","d":"M14.97 22.145l.013.008a5.41 5.41 0 006.732-.74l.756-.755a1.804 1.804 0 000-2.552l-3.19-3.187a1.803 1.803 0 00-2.55 0 1.803 1.803 0 01-2.55 0l-5.1-5.102a1.804 1.804 0 010-2.55 1.804 1.804 0 000-2.552L5.893 1.528a1.803 1.803 0 00-2.55 0l-.758.756a5.411 5.411 0 00-.738 6.734l.007.012a48.82 48.82 0 0013.117 13.115z"}})])
          )
        }
      }
    